export default "__VITE_ASSET__C8sqQ4ej__"